import React, { useState } from 'react';
import { questions } from './data/questions';
import QuestionCard from './components/QuestionCard';
import Result from './components/Result';
import Header from './components/Header';
import { NavBar } from '../../utility/navBar/Navbar';
import { Contact } from '../../utility/contact/Contact';
import './Quiz.scss';

function Quiz() {
  const [current, setCurrent] = useState(0);
  const [styleScores, setStyleScores] = useState({});

  const handleAnswer = (weights) => {
    const updatedScores = { ...styleScores };
    for (const key in weights) {
      updatedScores[key] = (updatedScores[key] || 0) + weights[key];
    }
    setStyleScores(updatedScores);
    setCurrent(current + 1);
  };

  return (
    <div className="quiz-page">
      <NavBar theme="light" />
      <Header />
      <div className="quiz">
        {current < questions.length ? (
          <QuestionCard
            question={questions[current]}
            onSelect={handleAnswer}
          />
        ) : (
          <Result scores={styleScores} />
        )}
      </div>
      <Contact />
    </div>
  );
}

export default Quiz;